<app-header (contactClick)="scrollToFooter()"></app-header>

<app-loading></app-loading>

<div id="outlet-container">
  <router-outlet></router-outlet>
</div>
<app-footer #footerRef></app-footer>
